import { render, staticRenderFns } from "./squash_before_merge.vue?vue&type=template&id=900b9806"
import script from "./squash_before_merge.vue?vue&type=script&lang=js"
export * from "./squash_before_merge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports